export interface FullScreenLabels {
  open: string
  close: string
}

export const DEFAULT_FULLSCREEN_LABELS: FullScreenLabels = {
  open: 'Open in full screen',
  close: 'Exit full screen',
}
